module.exports = __webpack_public_path__ + "img/C.c5f76a9d.png";